<script lang="ts">
  import { type Business } from '../../lib/types';

  let {
    isOpen,
    mode,
    business = null,
    isLoading,
    error,
    industries,
    onsubmit,
    onclose,
  }: {
    isOpen: boolean;
    mode: 'create' | 'edit';
    business?: Business | null;
    isLoading: boolean;
    error: string;
    industries: string[];
    onsubmit: (data: { name: string; industry: string }) => void;
    onclose: () => void;
  } = $props();

  let name = $state('');
  let industry = $state('');

  // Reset form when modal opens
  $effect(() => {
    if (isOpen) {
      name = mode === 'edit' && business ? business.name : '';
      industry = mode === 'edit' && business ? (business.industry || '') : '';
    }
  });

  function handleSubmit(e: Event) {
    e.preventDefault();
    onsubmit({ name, industry });
  }

  const isCreate = $derived(mode === 'create');
  const title = $derived(isCreate ? 'Create Business' : 'Edit Business');
  const submitLabel = $derived(isCreate
    ? (isLoading ? 'Creating...' : 'Create Business')
    : (isLoading ? 'Saving...' : 'Save Changes')
  );
  const idPrefix = $derived(isCreate ? 'create' : 'edit');
</script>

{#if isOpen}
  <div class="modal-overlay" onclick={onclose}>
    <div class="modal" onclick={(e) => e.stopPropagation()}>
      <div class="modal-header">
        <h3>{title}</h3>
        <button class="btn-close" onclick={onclose}>&times;</button>
      </div>

      <form onsubmit={handleSubmit}>
        {#if error}
          <div class="form-error">{error}</div>
        {/if}

        <div class="form-group">
          <label for="{idPrefix}-business-name">Business Name *</label>
          <input
            id="{idPrefix}-business-name"
            type="text"
            bind:value={name}
            placeholder="Your Business Name"
            disabled={isLoading}
            autofocus={isCreate}
          />
        </div>

        <div class="form-group">
          <label for="{idPrefix}-business-industry">Industry</label>
          <select id="{idPrefix}-business-industry" bind:value={industry} disabled={isLoading}>
            <option value="">Select industry (optional)</option>
            {#each industries as ind}
              <option value={ind}>{ind}</option>
            {/each}
          </select>
        </div>

        {#if isCreate}
          <p class="form-help">
            This business will be created in your EQUOS workspace. You can add team members and warehouses after creation.
          </p>
        {/if}

        <div class="modal-actions">
          <button type="button" class="btn-secondary" onclick={onclose} disabled={isLoading}>
            Cancel
          </button>
          <button type="submit" class="btn-primary" disabled={isLoading}>
            {submitLabel}
          </button>
        </div>
      </form>
    </div>
  </div>
{/if}
